module.exports = __webpack_public_path__ + "static/media/closed.3d3b64c1.svg";